class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('#search-input');
    this.predictiveSearchResults = document.querySelector('#search-results');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = encodeURIComponent(this.input.value.trim());

    if (!searchTerm.length) {
      $(this.predictiveSearchResults).fadeOut(function () {
        $('.search__initial').fadeIn();
      });
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page&resources[options][fields]=variants.sku,variants.title,title&section_id=predictive-search`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        if (text.indexOf('no-results') != -1) {
          $('.navbar__search').addClass('search-results--no-results');
          return;
        }

        $('.navbar__search').removeClass('search-results--no-results');
        this.predictiveSearchResults.innerHTML = text;

        window.updateProductCardsWishlist?.();

        // Always ensure search__initial is hidden before showing results
        $('.search__initial').hide();
        this.open();
      })
      .catch((error) => {
        console.error(error);
        this.close();
      });
  }

  open() {
    $(this.predictiveSearchResults).fadeIn();
    console.log('open');
  }

  close() {
    $(this.predictiveSearchResults).fadeOut();
    console.log('close');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
